import React, {Component} from 'react';
import shared from '../../utils/shared.js'

class CircleImageInfoBlock extends Component {
    render() {
        let {
            borderRadius = '100%',
            src,
            srcset,
            name,
            size = this.props.size, //200,
            style,
            className
        } = this.props;

        const imageStyle = {
            display: 'block',
            borderRadius
        };

        const innerStyle = {
            textAlign: 'center',
            borderRadius
        };

        imageStyle.width = innerStyle.width = innerStyle.maxWidth = size;
        imageStyle.height = innerStyle.height = innerStyle.maxHeight = size;

        let inner, classes = [className, 'DonorAvatar'];
        if (this.props.image || src || srcset) {
            inner = <img className="DonorAvatar-inner" style={imageStyle} src={shared.dpath(this.props.mode, this.props.image.path, this.props.image.file_name, this.props.webkey)} srcSet={srcset} alt={name}/>
        } else {
            inner = <img className="DonorAvatar-inner" style={imageStyle} src="img/ui/default-user.png" srcSet={srcset} alt={name}/>
        }

        return (
            <span style={{position: 'relative', zIndex: 30}}>
            <span aria-label={name} className={classes.join(' ')} style={style}>
                <span className="DonorAvatar-inner" style={innerStyle}>
                    {inner}
                </span>
            </span>
            </span>
        )
    }
}

module.exports = CircleImageInfoBlock;



// WEBPACK FOOTER //
// ./src/Components/General/CircleImageInfoBlock.js